import {
	mailSendingAccountActivate,
	mailSendingAccountByID,
	mailSendingAccountCreate,
	mailSendingAccountDestroy,
	mailSendingAccountTest,
	mailSendingAccountUpdate,
	mailSendingAccountsList,
} from '@/services/mailSendingAccounts.service'

export default {
	namespaced: true,
	state: {
		accountsList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		account: {},
		accountsStatus: 'pending',
		accountSaveStatus: 'init',
		accountDeleteStatus: 'init',
		accountActivateStatus: 'init',
		accountTestStatus: 'init',
	},
	getters: {
		getAccountsList(state) {
			return state.accountsList
		},
		getAccount(state) {
			return state.account
		},
		getAccountsStatus(state) {
			return state.accountsStatus
		},
		getAccountSaveStatus(state) {
			return state.accountSaveStatus
		},
		getAccountDeleteStatus(state) {
			return state.accountDeleteStatus
		},
		getAccountActivateStatus(state) {
			return state.accountActivateStatus
		},
		getAccountTestStatus(state) {
			return state.accountTestStatus
		},
	},
	mutations: {
		ACCOUNTS_LIST(state, value) {
			state.accountsList = value
		},
		SET_ACCOUNT(state, value) {
			state.account = value
		},
		ACCOUNTS_STATUS(state, value) {
			state.accountsStatus = value
		},
		ACCOUNT_SAVE_STATUS(state, value) {
			state.accountSaveStatus = value
		},
		ACCOUNT_DELETE_STATUS(state, value) {
			state.accountDeleteStatus = value
		},
		ACCOUNT_ACTIVATE_STATUS(state, value) {
			state.accountActivateStatus = value
		},
		ACCOUNT_TEST_STATUS(state, value) {
			state.accountTestStatus = value
		},
	},
	actions: {
		async fetchAccountsList({ commit }, params) {
			commit('ACCOUNTS_STATUS', 'pending')
			try {
				const { data } = await mailSendingAccountsList(params)
				commit('ACCOUNTS_STATUS', 'init')
				commit('ACCOUNTS_LIST', data)
				return data
			} catch (error) {
				commit('ACCOUNTS_STATUS', 'init')
				throw error
			}
		},
		async fetchAccountByID({ commit }, params) {
			commit('ACCOUNTS_STATUS', 'pending')
			try {
				const { data } = await mailSendingAccountByID(params)
				commit('ACCOUNTS_STATUS', 'init')
				commit('SET_ACCOUNT', data.data)
				return data
			} catch (error) {
				commit('ACCOUNTS_STATUS', 'init')

				return error
			}
		},
		async saveNewAccount({ commit }, params) {
			commit('ACCOUNT_SAVE_STATUS', 'pending')
			try {
				const { data } = await mailSendingAccountCreate(params)
				commit('ACCOUNT_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('ACCOUNT_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateAccount({ commit }, params) {
			commit('ACCOUNT_SAVE_STATUS', 'pending')
			try {
				const { data } = await mailSendingAccountUpdate(params)
				commit('ACCOUNT_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('ACCOUNT_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteAccountByID({ commit }, params) {
			commit('ACCOUNT_DELETE_STATUS', 'pending')
			try {
				const { data } = await mailSendingAccountDestroy(params)
				commit('ACCOUNT_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('ACCOUNT_DELETE_STATUS', 'error')

				return error
			}
		},
		async activateAccount({ commit }, id) {
			commit('ACCOUNT_ACTIVATE_STATUS', 'pending')
			try {
				const { data } = await mailSendingAccountActivate(id)
				commit('ACCOUNT_ACTIVATE_STATUS', 'init')
				commit('SET_ACCOUNT', data.data)
				return data
			} catch (error) {
				commit('ACCOUNT_ACTIVATE_STATUS', 'error')
				throw error
			}
		},
		async testAccount({ commit }, id) {
			commit('ACCOUNT_TEST_STATUS', 'pending')
			try {
				const { data } = await mailSendingAccountTest(id)
				commit('ACCOUNT_TEST_STATUS', 'init')
				commit('SET_ACCOUNT', data.data)
				return data
			} catch (error) {
				// A failed test is a normal, expected outcome (wrong
				// credential, unverified domain) — not an error state for
				// the store to throw over. The controller still returns the
				// account with status/last_test_error updated on a 422.
				commit('ACCOUNT_TEST_STATUS', 'init')
				commit('SET_ACCOUNT', error?.response?.data?.data ?? {})
				throw error
			}
		},
	},
}
